import { FC } from 'react';

const CloseIcon: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0858 10.2898C11.138 10.3421 11.1795 10.4042 11.2078 10.4724C11.2361 10.5407 11.2506 10.6139 11.2506 10.6878C11.2506 10.7617 11.2361 10.8349 11.2078 10.9032C11.1795 10.9715 11.138 11.0335 11.0858 11.0858C11.0335 11.138 10.9715 11.1795 10.9032 11.2078C10.8349 11.2361 10.7617 11.2506 10.6878 11.2506C10.6139 11.2506 10.5407 11.2361 10.4724 11.2078C10.4042 11.1795 10.3421 11.138 10.2898 11.0858L5.62531 6.42055L0.960781 11.0858C0.855234 11.1913 0.71208 11.2506 0.562813 11.2506C0.413546 11.2506 0.270392 11.1913 0.164844 11.0858C0.0592961 10.9802 2.94241e-09 10.8371 0 10.6878C-2.94241e-09 10.5385 0.0592961 10.3954 0.164844 10.2898L4.83008 5.62531L0.164844 0.960781C0.0592961 0.855234 0 0.71208 0 0.562813C0 0.413546 0.0592961 0.270392 0.164844 0.164844C0.270392 0.0592961 0.413546 0 0.562813 0C0.71208 0 0.855234 0.0592961 0.960781 0.164844L5.62531 4.83008L10.2898 0.164844C10.3954 0.0592961 10.5385 -2.94241e-09 10.6878 0C10.8371 2.94241e-09 10.9802 0.0592961 11.0858 0.164844C11.1913 0.270392 11.2506 0.413546 11.2506 0.562813C11.2506 0.71208 11.1913 0.855234 11.0858 0.960781L6.42055 5.62531L11.0858 10.2898Z"
      transform="translate(3.375 3.375)"
      fill="currentColor"
    />
  </svg>
);

export default CloseIcon;
